import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import "./Pedidos.css";

import Navbar from "../../../components/parts/navbar/Navbar";
import TopLinks from "../../../components/parts/TopLinks/TopLinks";
import Menu from "../../../components/parts/menu/Menu";
import ClienteTabs from "../../../components/parts/ClienteTabs/ClienteTabs";
import VerificaToken from "../../../components/utils/VerificaToken";

import ListaPedidos from "./componentes/listaPedidos/ListaPedidos";
import ListaNotas from "./componentes/listaNotas/ListaNotas";
import ModalItens from "./componentes/modalItens/ModalItens";

export default function Pedidos() {

  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] =
    useState(false);

  const [loading, setLoading] =
    useState(true);

  const [aba, setAba] =
    useState("abertos");

  const [pedidos, setPedidos] =
    useState([]);

  const [notas, setNotas] =
    useState([]);

  const [modalAberto, setModalAberto] =
    useState(false);

  const [tituloModal, setTituloModal] =
    useState("");

  const [tipoModal, setTipoModal] =
    useState("");

  const [itensModal, setItensModal] =
    useState([]);

  useEffect(() => {
    carregarPedidos();
  }, []);

  async function carregarPedidos() {

    try {

      setLoading(true);

      const usuario =
        await VerificaToken();

      if (!usuario.login) {

        navigate("/", {
          replace: true,
        });

        return;

      }

      const res =
        await axios.post(
          "https://app.eliandroalimentos.com.br/api/cliente/retornapedidoscliente",
          {
            codcliente:
              usuario.codcliente,
          }
        );

      setPedidos(
        res.data.Pedidos || []
      );

      setNotas(
        res.data.Notas || []
      );

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }

  }

  function abrirItens(
    titulo,
    itens,
    tipo
  ) {

    setTituloModal(titulo);

    setItensModal(itens);

    setTipoModal(tipo);

    setModalAberto(true);

  }

  function formatarData(data) {

    if (!data) {
      return "-";
    }

    return new Date(data)
      .toLocaleDateString("pt-BR");

  }

  function moeda(valor) {

    return Number(valor || 0)
      .toLocaleString(
        "pt-BR",
        {
          style: "currency",
          currency: "BRL",
        }
      );

  }

  const hoje = new Date();

  hoje.setHours(0, 0, 0, 0);

  const pedidosAbertos =
    pedidos.filter((pedido) => {

      if (!pedido.dtfatura) {
        return false;
      }

      const dataFatura =
        new Date(pedido.dtfatura);

      if (
        isNaN(dataFatura.getTime())
      ) {
        return false;
      }

      dataFatura.setHours(
        0,
        0,
        0,
        0
      );

      return dataFatura > hoje;

    });

  const notasFaturadas = notas.filter(
    (nota) =>
      Number(nota.codnatureza) === 5102 ||
      Number(nota.codnatureza) === 5910
  );

  if (loading) {

    return (

      <div className="pedidos-loading">

        <div className="pedidos-spinner"></div>

        <span>
          Carregando pedidos...
        </span>

      </div>

    );

  }

  return (

    <div className="pedidos-container">

      <Navbar />

      <TopLinks
        onOpenMenu={() =>
          setMenuOpen(true)
        }
      />

      <Menu
        isOpen={menuOpen}
        onClose={() =>
          setMenuOpen(false)
        }
      />

      <ClienteTabs />

      <h1 className="pedidos-title">
        Pedidos
      </h1>

      <div className="pedidos-tabs">

        <button
          className={
            aba === "abertos"
              ? "pedidos-tab ativo"
              : "pedidos-tab"
          }
          onClick={() =>
            setAba("abertos")
          }
        >

          Abertos (
          {pedidosAbertos.length}
          )

        </button>

        <button
          className={
            aba === "faturados"
              ? "pedidos-tab ativo"
              : "pedidos-tab"
          }
          onClick={() =>
            setAba("faturados")
          }
        >

          Faturados (
          {notasFaturadas.length}
          )

        </button>

      </div>

      {

        aba === "abertos"

          ?

          <ListaPedidos
            pedidos={
              pedidosAbertos
            }
            moeda={moeda}
            formatarData={
              formatarData
            }
            abrirItens={
              abrirItens
            }
          />

          :

          <ListaNotas
            notas={notas}
            moeda={moeda}
            formatarData={
              formatarData
            }
            abrirItens={
              abrirItens
            }
          />

      }

      <ModalItens
        aberto={modalAberto}
        titulo={tituloModal}
        tipo={tipoModal}
        itens={itensModal}
        moeda={moeda}
        onClose={() =>
          setModalAberto(false)
        }
      />

    </div>

  );

}